import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { assetUrl, errMsg } from "@/lib/api";

export default function AssetsTab({ api, projectId, assets, setAssets, onPick }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [list, setList] = useState(assets || null);
  useEffect(() => {
    if (assets) { setList(assets); return; }
    api.get(`/projects/${projectId}/assets`).then(({ data }) => setList(data)).catch(() => setList([]));
  }, [api, projectId, assets]);
  const images = (list || []).filter((a) => a.content_type?.startsWith("image/"));
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", file); fd.append("kind", "image");
    try {
      const { data } = await api.post(`/projects/${projectId}/assets`, fd);
      setAssets?.((xs) => [data, ...xs]); setList((xs) => [data, ...(xs || [])]);
      onPick(data.url, { provider: "upload" });
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="image-picker-assets">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-slate-500">Immagini caricate in questo progetto (incluse quelle generate con AI).</p>
        <Button size="sm" variant="outline" onClick={() => input.current?.click()} disabled={busy} data-testid="image-picker-upload-btn">
          {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Upload size={14} className="mr-1.5" />}Carica nuova
        </Button>
        <input ref={input} type="file" hidden accept="image/*" onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} data-testid="image-picker-file-input" />
      </div>
      {list === null ? <p className="mt-6 text-sm text-slate-500">Caricamento…</p> : (
        <div className="mt-4 grid grid-cols-3 sm:grid-cols-4 gap-2">
          {images.map((a) => (
            <button key={a.id} onClick={() => onPick(a.url, { provider: "upload" })} className="group rounded-lg border overflow-hidden bg-slate-50 text-left hover:border-sky-400 transition-colors" data-testid={`image-picker-asset-${a.id}`}>
              <img src={assetUrl(a.url)} alt={a.name} className="aspect-[4/3] w-full object-cover" />
              <p className="px-2 py-1 text-[10px] text-slate-600 truncate">{a.folder === "AI" ? "AI · " : ""}{a.name}</p>
            </button>
          ))}
          {!images.length && <p className="col-span-full text-sm text-slate-500">Nessuna immagine: caricane una o usa le foto stock.</p>}
        </div>
      )}
    </div>
  );
}
